export const GET_MEMBER_INFO = 'GET_MEMBER_INFO'; 
export const GET_MEMBER_INFO_SUCCESS = 'GET_MEMBER_INFO-SUCCESS'; 
export const SET_MEMBER_INFO = 'SET_MEMBER_INFO';
export const SET_MEMBER_TOKEN= 'SET_MEMBER_TOKEN';
export const SET_MEMBER_PROFILE = 'SET_MEMBER_PROFILE';
export const SET_MEMBER_PHOTO = 'SET_MEMBER_PHOTO';
export const UPDATE_MEMBER_INFO = 'UPDATE_MEMBER_INFO';